export default __webpack_public_path__ + "static/media/IPManagement.aff53ea4.svg";